import $ from 'jquery';
import Animation from 'modules/animation/animation';
import Numbered from 'input.numbered';
import Prefixed from 'modules/prefixed/prefixed';

export default class {
	constructor(options) {
		const defaults = {
			el: '#yotaVoiceMobileApp',
			dom: {
				item: '.js-voice-mobile-app-item',
				send: '#yotaVoiceMobileAppSend',
				resend: '#yotaVoiceMobileAppResend',
				form: '#yotaVoiceMobileAppForm',
				input: '#yotaVoiceMobileAppInput',
				circle: '#yotaVoiceMobileAppNext'
			},
			classes: {
				itemActive: 'b-voice-mobile-app__item_state_active',
				form: 'b-voice-mobile-app_state_form',
				end: 'b-voice-mobile-app_state_end',
				error: 'b-voice-mobile-app_state_error'
			}
		};
		this.options = $.extend(true, {}, defaults, options);
		this.$el = $(this.options.el);
		this.prefixed = new Prefixed();
		this.current = Number(this.$el.data('current')) || 1;
		this.deg = this.current * 90 - 315;
		this.interval = false;
		return this;
	}

	getDom() {
		this.$item = this.$el.find(this.options.dom.item);
		this.$send = this.$el.find(this.options.dom.send);
		this.$resend = this.$el.find(this.options.dom.resend);
		this.$form = this.$el.find(this.options.dom.form);
		this.$input = this.$el.find(this.options.dom.input);
		this.$circle = this.$el.find(this.options.dom.circle);
		return this;
	}

	onClick(event) {
		const $target = $(event.currentTarget);
		if ($target.hasClass(this.options.classes.itemActive)) {
			return;
		}
		const value = Number($target.data('value'));
		this.setCurrent(value);
		this.setAuto();
	}

	setCurrent(current) {
		let delta = this.current - current;
		if (delta > 1) {
			delta -= 4;
		}
		if (delta == -3) {
			delta += 4;
		}
		this.current = current;
		this.deg = this.deg - delta * 90;
		this.$el.attr('data-current', this.current);
		this.$circle.css(this.prefixed.css.transform, 'translateX(-50%) translateY(-50%) translateZ(0) rotate(' + this.deg + 'deg)');
	}

	onResend() {
		this.$input.val('');
		this.$el
			.removeClass(this.options.classes.end)
			.removeClass(this.options.classes.error)
			.addClass(this.options.classes.form);
	}

	onSubmit(event) {
		const self = this;
		event.preventDefault();
		if (self.validate() > 0) {
			$.ajax({
				url: self.$form.attr('action'),
				type: self.$form.attr('method'),
				data: self.$form.serialize(),
				dataType: 'json',
				success: function (json) {
					if (json && json.success) {
						self.$el
							.removeClass(self.options.classes.form)
							.removeClass(self.options.classes.error)
							.addClass(self.options.classes.end);
					} else {
						self.$el
							.removeClass(self.options.classes.form)
							.removeClass(self.options.classes.end)
							.addClass(self.options.classes.error);
					}
				}
			});
		} else {
			this.form.play('shake');
		}
	}

	init() {
		this.$item.on('click', this.onClick.bind(this));
		this.$send.on('click', this.onResend.bind(this));
		this.$resend.on('click', this.onResend.bind(this));
		this.$form.on('submit', this.onSubmit.bind(this));
		this.numbered = new Numbered(this.$input, {placeholder: true});
		this.form = new Animation({el: this.$form});
		return this;
	}


	validate() {
		return this.numbered.validate();
	}

	setAuto() {
		const self = this;
		clearInterval(self.interval);
		self.interval = setInterval(function () {
			let current = self.current + 1;
			if (current > 4) {
				current = 1;
			}
			self.setCurrent(current);
		}, 4000);
	}

	render() {
		if (this.$el.length) {
			this.getDom();
			this.init();
			this.setAuto();
		}
		return this;
	}
}



// WEBPACK FOOTER //
// ./app/portlets/site/voice-mobile-app/voice-mobile-app.js